import $ from "jquery";
import 'slick-carousel';
import { FireComponent } from "@component";

export class QuoteSlider extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $slider: this.findElement("small-slider"),
      $center: this.findElement("center-slider"),
    };
  }

  initSlider() {
    this.elements.$slider.slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows:false,
      centerMode: true,
      centerPadding: "0",
      asNavFor: ".center-slider",
    });

    this.elements.$center.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      fade: true,
      centerMode: true,
      centerPadding: "10px",
      asNavFor: ".slider",
    });

    if(window.innerWidth > 767) {
      $(".slick-slide").each(function() {
        var width = $(this).width();
        $(this).height(width);
      });
    }
  }

  init() {
    if (!this.componentExists) return;
    this.initSlider();
  }
}
